/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDCornerUpRightIcon16Light } from './ArrowDCornerUpRightIcon16Light';
import { ArrowDCornerUpRightIcon16Regular } from './ArrowDCornerUpRightIcon16Regular';
import { ArrowDCornerUpRightIcon16Solid } from './ArrowDCornerUpRightIcon16Solid';
import { ArrowDCornerUpRightIcon20Light } from './ArrowDCornerUpRightIcon20Light';
import { ArrowDCornerUpRightIcon20Regular } from './ArrowDCornerUpRightIcon20Regular';
import { ArrowDCornerUpRightIcon20Solid } from './ArrowDCornerUpRightIcon20Solid';
import { ArrowDCornerUpRightIcon24Regular } from './ArrowDCornerUpRightIcon24Regular';
import { ArrowDCornerUpRightIcon24Solid } from './ArrowDCornerUpRightIcon24Solid';
import { ArrowDCornerUpRightIcon32Regular } from './ArrowDCornerUpRightIcon32Regular';
import { ArrowDCornerUpRightIcon64Regular } from './ArrowDCornerUpRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowDCornerUpRightIcon16Light,
        regular: ArrowDCornerUpRightIcon16Regular,
        solid: ArrowDCornerUpRightIcon16Solid,
    },
    20: {
        light: ArrowDCornerUpRightIcon20Light,
        regular: ArrowDCornerUpRightIcon20Regular,
        solid: ArrowDCornerUpRightIcon20Solid,
    },
    24: {
        regular: ArrowDCornerUpRightIcon24Regular,
        solid: ArrowDCornerUpRightIcon24Solid,
    },
    32: {
        regular: ArrowDCornerUpRightIcon32Regular,
    },
    64: {
        regular: ArrowDCornerUpRightIcon64Regular,
    },
};
export var ArrowDCornerUpRightIcon = forwardRef('ArrowDCornerUpRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
